// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid_grid__1VrQ7","row":"Grid_row__OOJQC","start":"Grid_start__1ZqXb","col":"Grid_col__9rcrJ"};